import Swiper from "swiper";
import "swiper/css";

export default function () {
    const root = document.querySelector(
        '.o-modelo__swiper[data-swiper="modelo"]',
    );
    if (!root) return;

    const slider = new Swiper(root, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        autoHeight: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 14,
                allowTouchMove: false,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 18,
                allowTouchMove: false,
            },
        },
    });

    return slider;
}
